module.exports = __webpack_public_path__ + "img/new3-img5.41c3682c.jpg";